import { createContext, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userLogIn, userLogout } from '../app/reducer/authReducer';

const AuthContext = createContext(null);

///////////////////////////////////////////////////////////////////////////////////////////////////////

export const UserAuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { Token } = useSelector((state) => state.auth);

  const Logout = () => {
    dispatch(userLogout());

    localStorage.clear();
    localStorage.removeItem('token');
    //! clearing persist:root from localstorage
    localStorage.removeItem('persist:root');
  };

  const LogIn = (user, token) => {
    dispatch(userLogIn({ GetUser: user, Token: token }));
    localStorage.setItem('token', token);
  };

  return <AuthContext.Provider value={{ Token, Logout, LogIn }}>{children}</AuthContext.Provider>;
};
///////////////////////////////////////////////////////////////////////////////////////////////////////

// Creating the custom Hook
export const useAuth = () => useContext(AuthContext);
